module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pictureWall"
    },
    on: {
      "click": _vm.closeTopPickers
    }
  }, [_c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "identifier": "mainPictureWall"
    }
  }), _vm._v(" "), (_vm.pictureWallActive) ? _c('div', {
    class: {
      outer: true, opacityHide: _vm.hideImage
    },
    style: ({
      backgroundImage: 'url(' + _vm.activeBG + ')'
    }),
    attrs: {
      "id": "zoomElement"
    }
  }, [(_vm.activeOverlay) ? _c('div', {
    staticClass: "overlayBG",
    style: ({
      backgroundImage: 'url(' + _vm.activeOverlay + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.currentPictureWall) ? _c('div', {
    staticClass: "articlesContainer",
    style: ({
      left: _vm.leftWallPosition
    }),
    attrs: {
      "id": "draggableContainer"
    }
  }, _vm._l((_vm.currentPictureWall.articles), function(article, index) {
    return _c('div', {
      key: index,
      class: {
        blink: _vm.highlightPictureWallItems, item: true, active: _vm.currentPictureWallField == _vm.getArticleFieldID(article.item), hasFrame: _vm.chosenFrames[_vm.getArticleFieldID(article.item)], hasArticle: _vm.chosenArticles[_vm.getArticleFieldID(article.item)], landscape: _vm.checkLandScape(article)
      },
      style: ({
        top: article.top + '%',
        left: article.left + '%'
      }),
      attrs: {
        "data-size": article.size,
        "data-position": index,
        "data-item-index": index
      }
    }, [(!_vm.chosenArticles[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "inner"
    }, [_vm._v("\n            " + _vm._s(article.size) + "\n          ")]) : _c('div', {
      staticClass: "chosenArticle",
      style: ({
        background: 'url(' + _vm.getArticleImage(_vm.chosenArticles[index + 1]) + ')'
      })
    }), _vm._v(" "), (_vm.chosenFrames[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "frame"
    }, [_c('img', {
      attrs: {
        "src": _vm.getFrameImage(article)
      }
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.showWelcome) ? _c('welcome') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentPicker == 'articles') ? _c('notification-tooltip', {
    key: "buyHere",
    attrs: {
      "click-hide": "true",
      "position": "middle",
      "identifier": "heartInfo",
      "show-once": true,
      "title": "heartInfoTitle",
      "text": "heartInfo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.steps.complete && _vm.currentPicker == '') ? _c('notification-tooltip', {
    attrs: {
      "position": "buyButton",
      "title": "purchaseNowTitle",
      "text": "purchaseNow",
      "identifier": "buyHere"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.background
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e431ac!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/PictureWall/PictureWall.vue
// module id = 150
// module chunks = 0